import { Box, styled } from '@mui/material';

export const ActionButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '16px',
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  '& > button': {
    flexShrink: 0,
    minWidth: '150px'
  }
}));
